import React from 'react';
import { GraduationCap, Briefcase, User } from 'lucide-react';

export default function TeamCard({ member }) {
  return (
    <div className="group bg-white rounded-2xl border border-[#D9E8E5] overflow-hidden shadow-card hover:shadow-elevated transition-all duration-300 flex flex-col justify-between hover:-translate-y-1">
      <div>
        {/* Photo Container - Vertically Increased Height */}
        {member.image ? (
          <div className="relative h-80 sm:h-96 md:h-[400px] overflow-hidden bg-[#123B5D]">
            <img
              src={member.image}
              alt={member.name}
              loading="lazy"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#123B5D]/90 via-[#123B5D]/20 to-transparent"></div>

            <div className="absolute bottom-4 left-4 right-4">
              <h3 className="font-serif text-2xl text-white font-normal leading-snug">
                {member.name}
              </h3>
            </div>
          </div>
        ) : (
          <div className="relative p-6 bg-[#123B5D] text-white border-b border-[#0F766E]/30 min-h-[160px] flex flex-col justify-end">
            <div className="w-10 h-10 rounded-xl bg-[#0D273E] text-[#2A9D8F] flex items-center justify-center mb-3 border border-white/10">
              <User className="w-5 h-5 text-[#2A9D8F]" />
            </div>
            <h3 className="font-serif text-2xl text-white font-normal leading-snug">
              {member.name}
            </h3>
          </div>
        )}

        {/* Details Body - Designation & Credentials */}
        <div className="p-6 space-y-3.5">
          {/* Designation */}
          <div className="flex items-center gap-2.5 text-xs text-[#18323A] bg-[#F5FAF9] p-3 rounded-xl border border-[#D9E8E5]">
            <Briefcase className="w-4 h-4 text-[#0F766E] flex-shrink-0" />
            <span className="text-[#0F766E] font-semibold">{member.designation}</span>
          </div>

          {/* Credentials */}
          <div className="flex items-start gap-2.5 text-xs text-[#18323A] bg-[#F5FAF9] p-3 rounded-xl border border-[#D9E8E5]">
            <GraduationCap className="w-4 h-4 text-[#0F766E] flex-shrink-0 mt-0.5" />
            <span className="text-[#64748B] font-medium leading-relaxed">{member.qualification}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
